var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62174 17.8825C8.82037 18.0925 9.2025 18.3 10 18.3H14C14.7975 18.3 15.1796 18.0925 15.3783 17.8825C15.5887 17.66 15.8 17.2169 15.8 16.3287V9.07189H8.2V16.3287C8.2 17.2169 8.41129 17.66 8.62174 17.8825ZM7 7.87189H17V16.3287C17 18.4429 16 19.5 14 19.5H10C8 19.5 7 18.4429 7 16.3287V7.87189Z",
    fill: "#272932"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3911 5.69531L9.74287 6.34352C9.67021 6.41618 9.58327 6.46599 9.49094 6.49311C9.43196 6.51259 9.3689 6.52313 9.30339 6.52313H6.76562C6.43555 6.52313 6.16797 6.25555 6.16797 5.92547C6.16797 5.5954 6.43555 5.32782 6.76562 5.32782H9.05893L9.71021 4.67654C9.81794 4.56881 9.95705 4.5113 10.0986 4.50355C10.1201 4.5012 10.1419 4.5 10.1641 4.5H13.8271C13.8728 4.5 13.9173 4.50513 13.9601 4.51486C14.0704 4.53741 14.1754 4.59123 14.2607 4.67655L14.912 5.32782H17.237C17.567 5.32782 17.8346 5.5954 17.8346 5.92547C17.8346 6.25555 17.567 6.52313 17.237 6.52313H14.6992C14.6673 6.52313 14.636 6.52063 14.6055 6.51582C14.4677 6.50577 14.333 6.44848 14.228 6.34352L13.5798 5.69531H10.3911Z",
    fill: "#272932"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGray);
export default __webpack_public_path__ + "static/media/delete_gray.b6cd275c4019b616153c900b412e7b15.svg";
export { ForwardRef as ReactComponent };